const Mastermind = () => {
    window.location.replace('https://the100club.notion.site/Mastermind-Guide-c09e426ba0c045f087a30c32bedf4c99?pvs=4');
};

export default Mastermind;
